import { ButtonProps } from './types';
import { ButtonSizeCanonical, ButtonSizeLegacy } from './types/button-size';

const LEGACY_SIZE_MAP = {
  large: 'xl',
  default: 'lg',
  small: 'md',
} as const satisfies Record<ButtonSizeLegacy, ButtonSizeCanonical>;

const normalizeSizeValue = (
  size: string | null | undefined
): string | null | undefined => {
  if (size == null) return size;

  return Object.prototype.hasOwnProperty.call(LEGACY_SIZE_MAP, size)
    ? LEGACY_SIZE_MAP[size as ButtonSizeLegacy]
    : size;
};

export function normalizeSize(size: ButtonProps['size']): ButtonProps['size'] {
  if (size == null) return size;

  if (typeof size === 'string') {
    // size is non-null here; normalizeSizeValue returns a non-null string in this case
    return normalizeSizeValue(size) as ButtonProps['size'];
  }

  if (Array.isArray(size)) {
    return size.map((value) =>
      normalizeSizeValue(value)
    ) as ButtonProps['size'];
  }

  // Responsive object (e.g. { base: 'small', md: 'lg' })
  return Object.fromEntries(
    Object.entries(size).map(([bp, s]) => [bp, normalizeSizeValue(s)])
  ) as ButtonProps['size'];
}
